import { useState } from "react";
import { FaUserCircle, FaCaretDown } from "react-icons/fa";

import { useDashboardContext } from "@/layouts/dashboard-layout";

import { LogoutContainerWrapper } from "@/components/wrappers";

const LogoutContainer = () => {
  const [showLogout, setShowLogout] = useState(false);
  const { user, logoutUser } = useDashboardContext();

  return (
    <LogoutContainerWrapper>
      <button className="btn logout-btn" type="button" onClick={() => setShowLogout(prev => !prev)}>
        {user.avatar ? <img className="img" src={user.avatar} alt="avatar" /> : <FaUserCircle />}
        {user?.name}
        <FaCaretDown />
      </button>
      <div className={`dropdown ${showLogout ? "show-dropdown" : ""}`}>
        <button className="dropdown-btn" type="button" onClick={logoutUser}>
          logout
        </button>
      </div>
    </LogoutContainerWrapper>
  );
};

export default LogoutContainer;
